var _rect, _text, _path, _circle, _circle2, _path2, _text2, _text3, _text4, _circle3, _path3, _circle4, _circle5, _circle6, _text5, _text6, _text7, _circle7, _path4, _text8, _text9, _text0, _circle8, _path5, _path6, _text1, _text10, _text11, _circle9, _circle0, _path7, _text12, _text13, _text14, _rect2, _circle1, _text15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportControlledImplementationFiveStagePathMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 620,
    height: 1160,
    viewBox: "0 0 620 1160",
    role: "img",
    "aria-label": "Controlled implementation mobile path",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 620,
    height: 1160,
    rx: 38,
    fill: "#FFFFFF",
    stroke: "#D5E3F2"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 62,
    fill: "#087CFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 13,
    fontWeight: 850,
    letterSpacing: 1.5
  }, "CONTROLLED IMPLEMENTATION PATH")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92 156v766",
    stroke: "#BEDAF4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 164,
    r: 39,
    fill: "#087CFF",
    fillOpacity: 0.12,
    stroke: "#087CFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.3,
    cy: 161.3,
    r: 9,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 168.5l9 9",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 147,
    fill: "#087CFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "01")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 182,
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 25,
    fontWeight: 850
  }, "Discover")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 215,
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 650
  }, "Sites, roles, evidence and owners")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 338,
    r: 39,
    fill: "#F54291",
    fillOpacity: 0.12,
    stroke: "#F54291"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5 330.8h27M78.5 338h27M78.5 345.2h27",
    fill: "none",
    stroke: "#F54291",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.6,
    cy: 330.8,
    r: 2.7,
    fill: "#F4F8FD",
    stroke: "#F54291",
    strokeWidth: 1.9800000000000002
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.3,
    cy: 338,
    r: 2.7,
    fill: "#F4F8FD",
    stroke: "#F54291",
    strokeWidth: 1.9800000000000002
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.1,
    cy: 345.2,
    r: 2.7,
    fill: "#F4F8FD",
    stroke: "#F54291",
    strokeWidth: 1.9800000000000002
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 321,
    fill: "#F54291",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "02")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 356,
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 25,
    fontWeight: 850
  }, "Configure")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 389,
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 650
  }, "Requirement matrix and validity rules")), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 512,
    r: 39,
    fill: "#F5AE35",
    fillOpacity: 0.12,
    stroke: "#F5AE35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3 522.8h23.400000000000002v-8.1M92 498.5v18m-6.3-6.3 6.3 6.3 6.3-6.3",
    fill: "none",
    stroke: "#F5AE35",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 495,
    fill: "#F5AE35",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "03")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 530,
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 25,
    fontWeight: 850
  }, "Import")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 563,
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 650
  }, "Allocations and existing records")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 686,
    r: 39,
    fill: "#4BB5FF",
    fillOpacity: 0.12,
    stroke: "#4BB5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4 674.3h19.8l6.3 6.3v18h-26.1z",
    fill: "none",
    stroke: "#4BB5FF",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7 687.8l4.5 4.5 9-9.9",
    fill: "none",
    stroke: "#4BB5FF",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 669,
    fill: "#4BB5FF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "04")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 704,
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 25,
    fontWeight: 850
  }, "Validate")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 737,
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 650
  }, "Operational outcomes with stakeholders")), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 860,
    r: 39,
    fill: "#30D6A1",
    fillOpacity: 0.12,
    stroke: "#30D6A1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 860,
    r: 10.8,
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92 843.8v4.5m0 23.400000000000002v4.5M75.8 860h4.5m23.400000000000002 0h4.5M80.3 848.3l3.6 3.6m16.2 16.2l3.6 3.6m0-23.400000000000002-3.6 3.6m-16.2 16.2-3.6 3.6",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 843,
    fill: "#30D6A1",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "05")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 878,
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 25,
    fontWeight: 850
  }, "Automate")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 911,
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 650
  }, "Forecasting, scheduling and passports")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 1042,
    width: 536,
    height: 76,
    rx: 20,
    fill: "#E7F8F2"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 1080,
    r: 6,
    fill: "#30D6A1"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 1086,
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "Automation begins only after governed outcomes are validated.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportControlledImplementationFiveStagePathMobile);
export default __webpack_public_path__ + "static/media/work-passport-controlled-implementation-five-stage-path-mobile.d482198f840432546a2254b07980fce3.svg";
export { ForwardRef as ReactComponent };